// src/api/productApi.js
import api from './api';

export const getProducts = (options = {}) => {
  const { includeImages = false } = options;
  return api.get('/products', {
    params: includeImages ? { includeImages: true } : undefined,
  });
};

export const createProduct = (formData) => {
  return api.post('/Products', formData);
};

export const updateProduct = (id, formData) => {
  return api.put(`/Products/${id}`, formData);
};

export const updateProductSortPrice = (id, sortId, price) => {
  return api.patch(`/Products/${id}/sorts/${sortId}/price`, { price });
};

export const getProductImage = (id) => {
  return api.get(`/Products/${id}/image`, { responseType: 'blob' });
};

export const deleteProduct = (SKU) => {
  return api.delete(`/Products/${SKU}`);
};

export const addProductQuantity = (SKU, payload) => {
  return api.put(`/Products/sku/${SKU}/add`, payload);
};

export const removeProductQuantity = (SKU, payload) => {
  return api.put(`/Products/sku/${SKU}/remove`, payload);
};

export const getProductBySKU = (SKU, options = {}) => {
  const { includeImages = false } = options;
  return api.get(`/Products/sku/${SKU}`, {
    params: includeImages ? { includeImages: true } : undefined,
  });
};
